// extracted by mini-css-extract-plugin
module.exports = {"edit":"EditButton_edit__1YGPS","editMode":"EditButton_editMode__2Ipqg","nonEditMode":"EditButton_nonEditMode__1th2W"};